import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, finalize, map, Subscription, tap, timer } from 'rxjs';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';

// a function for making delay in implementations
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const copyToClipboard = (value: string) => {
	navigator.clipboard.writeText(value).then(
		function () {},
		function () {}
	);
};

export const unloadWindowEvent = (func: () => void) =>
	fromEvent(window, 'unload').subscribe(() => {
		func();
	});

export function timeout(func: () => void, timeout = 100) {
	const sub: Subscription = timer(timeout)
		.pipe(
			tap(() => func()),
			finalize(() => sub.unsubscribe())
		)
		.subscribe();
}

export const getParamFromRoute = (name: string) => {
	return inject(ActivatedRoute).params.pipe(
		filter(params => params[name]),
		map(params => params[name])
	);
};

export const disableConsoleFunctions = () => {
	if (window) {
		window.console.log = () => null;
		window.console.assert = () => null;
		window.console.clear = () => null;
		window.console.count = () => null;
		window.console.countReset = () => null;
		window.console.debug = () => null;
		window.console.dir = () => null;
		window.console.error = () => null;
		window.console.group = () => null;
		window.console.groupCollapsed = () => null;
		window.console.groupEnd = () => null;
		window.console.info = () => null;
		window.console.table = () => null;
		window.console.time = () => null;
		window.console.timeEnd = () => null;
		window.console.timeStamp = () => null;
		window.console.trace = () => null;
		window.console.warn = () => null;
	}
};
